import React from "react";
import Routes from "./routes";
import { ThemeProvider } from "./context/DarkMode";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  return <ThemeProvider><Routes /></ThemeProvider>;
}
